const quoteSteps = [
  {
    icon: '/images/quoting/active/supplier.svg',
    placeholder: "We're reviewing your RFQ",
    description: 'Reviewing your product and requirements.',
    loading: true,
    done: false
  },
  {
    icon: '/images/quoting/active/reached.svg',
    placeholder: 'Match with the right factory',
    description: 'Identifying our best-fit facility for your product.',
    loading: false,
    done: false
  },
  {
    icon: '/images/quoting/active/engaging.svg',
    placeholder: 'Engage select factories',
    description: 'Validating specs, materials, and production requirements.',
    loading: false,
    done: false
  },
  {
    icon: '/images/quoting/active/received.svg',
    placeholder: 'Receive production quotes',
    description: 'Review your quotes and move into sampling.',
    loading: false,
    done: false
  }
];

export default quoteSteps;
